export const EMAIL_SIGNATURE = 'EMAIL_SIGNATURE';
export const AUTO_ASSIGNMENT = 'AUTO_ASSIGNMENT';
export const STATUS_SYNC_INFO = 'STATUS_SYNC_INFO';